import React from "react";

const CategoryThree = () => {
  return (
    <>
      {/* <!-- cta area start --> */}
      <div className="tp-cta-area pt-140">
        <div className="container">
          <div className="tp-cta-wrapper">
            <div className="row">
              <div className="col-12">
                <div className="tp-section-wrapper text-center">
                  <span className="tp-section-subtitle mb-25">
                    What do you know about that
                  </span>
                  <h2 className="tp-section-title">
                    Modern advisory services devised for companies <br />&
                    businesses both big and small
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- cta end end --> */}
    </>
  );
};

export default CategoryThree;
